import { mergeProps as _mergeProps, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "filter-form-wrapper"
};
import { computed, reactive, ref, watch } from 'vue';
import { omit } from '@/utils';
export default {
  __name: 'mg-query-filter-form',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    showAction: {
      type: Boolean,
      default: true
    }
  },
  emits: ['filter', 'cancel', 'reset', 'changed'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const formRef = ref();
    const props = __props;
    const emit = __emit;
    const defaultFormItem = [{
      align: 'left',
      span: 24,
      slots: {
        default: 'action'
      }
    }];
    const formItems = computed(() => {
      if (props.showAction) {
        return [...defaultFormItem, ...props.items];
      }
      return props.items;
    });
    const formOptions = reactive({
      padding: true,
      titleColon: true,
      titleAlign: 'right',
      titleWidth: 120,
      data: {}
    });
    watch(() => formOptions.data, val => {
      emit('changed', val);
    }, {
      deep: true,
      immediate: true
    });
    const formEvents = {
      submit() {
        emit('filter', omit({
          ...formOptions.data
        }));
      },
      reset() {
        emit('reset', {});
      },
      cancel() {
        emit('cancel');
      }
    };
    const submit = () => {
      !!formRef.value && formRef.value.submit();
    };
    const reset = () => {
      !!formRef.value && formRef.value.reset();
    };
    const cancel = () => {
      emit('cancel');
    };
    const getData = () => {
      return formOptions.data;
    };
    __expose({
      getData,
      submit,
      reset,
      cancel
    });
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      const _component_vxe_form = _resolveComponent("vxe-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_form, _mergeProps({
        ref_key: "formRef",
        ref: formRef
      }, formOptions, _toHandlers(formEvents), {
        items: formItems.value
      }), _createSlots({
        action: _withCtx(() => [_createVNode(_component_vxe_button_group, null, {
          default: _withCtx(() => [_createVNode(_component_vxe_button, {
            status: "success",
            type: "submit"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("提交", -1)]))]),
            _: 1
          }), _createVNode(_component_vxe_button, {
            type: "reset"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("重置", -1)]))]),
            _: 1
          }), _createVNode(_component_vxe_button, {
            status: "danger",
            onClick: formEvents.cancel
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("取消", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 2
      }, [_renderList(Object.keys(_ctx.$slots), key => {
        return {
          name: key,
          fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
            key: key
          }, scope))])
        };
      })]), 1040, ["items"])]);
    };
  }
};